import React, { useEffect, useState } from 'react';
import { Button, Flex, Modal, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import './index.scss';
import { useUpdateConfirmModal } from 'hooks/useConfirmModal';
import { initialStatus } from '.';

interface ErrorRequestConfirmModalProps {
  translate: any;
  icon: any;
  title: any;
  subtitle: any;
}

const { Text, Title } = Typography;

const ErrorRequestConfirmModal = ({
  translate,
  icon,
  title,
  subtitle,
}: ErrorRequestConfirmModalProps) => {
  const { modalStatus, setUpdateStatus } = useUpdateConfirmModal();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleClose = () => {
    setIsModalOpen(false);
    setUpdateStatus(initialStatus);
  };

  useEffect(() => {
    if (modalStatus?.isCanceled) {
      setIsModalOpen(true);
    }
  }, [modalStatus]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleClose}
      footer={null}
      width={480}
      closeIcon={false}
      closable={true}
      centered={true}
      className="transaction-confirm-modal"
    >
      <Flex vertical className="modal-container">
        <Flex
          vertical
          align="center"
          justify="center"
          className="modal-header"
        >
          <div className="icon-container">
            {icon || <CheckCircleFilled className="success-icon" />}
          </div>
          <Title level={4} className="modal-title">
            {title}
          </Title>
          {subtitle && (
            <Text className="modal-subtitle">{subtitle}</Text>
          )}
        </Flex>

        <Flex vertical className="action-container">
          <Button
            type="primary"
            size="large"
            onClick={handleClose}
            className="confirm-button"
          >
            {translate?.('Ok')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ErrorRequestConfirmModal;
